import { DetailsChildrenTab, type DetailsPageProps } from 'app/main/components/page-layouts';

import ChronologyListItem from 'app/main/modules/chronology/ChronologyListItem';
import OpportunitiesListItem from 'app/main/modules/opportunities/OpportunitiesListItem';
import ContractsListItem from 'app/main/modules/contracts/ContractsListItem';
import OrdersListItem from 'app/main/modules/orders/OrdersListItem';
import ProjectsListItem from 'app/main/modules/projects/ProjectsListItem';
import ActivitiesListItem from 'app/main/modules/activities/ActivitiesListItem';
import MarketingActionsListItem from 'app/main/modules/marketingactions/MarketingActionsListItem';
import CommercialCampaignsListItem from 'app/main/modules/commercialcampaigns/CommercialCampaignsListItem';
import TicketsListItem from 'app/main/modules/tickets/TicketsListItem';
import CompaniesListItem from 'app/main/modules/companies/CompaniesListItem';

import DemsRecipientsExternalTab from 'app/main/modules/dems/dems-recipients/DemsRecipientsExternalTab';
import PhoneCallsChartTab from 'app/main/submodules/phonecalls/PhoneCallsChartTab';

import PeoplesDetailsTab from './tabs/PeopleDetailsTab';
import PeopleContactTab from './tabs/PeopleContactTab';

import PeopleListItem from '../PeopleListItem';

const tabs: DetailsPageProps['tabs'] = [
	{
		id: 'summary',
		title: 'TAB_SUMMARY',
		content: props => <PeoplesDetailsTab {...props} />
	},
	{
		id: 'contacts',
		title: 'TAB_CONTACTS',
		disabled: ({ isEdit }) => isEdit,
		content: ({ model }) => <PeopleContactTab itemUid={model.peop_uid} />
	},
	{
		id: 'chronology',
		title: 'MODULE_CHRONOLOGY_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('chronology') || authorizer.cannot('view', 'chronology'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="chronology"
				content={{ type: 'list', itemLayout: ChronologyListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'chro_peop_uid', filt_clause: 'equals', filt_value: model.peop_uid }]}
			/>
		)
	},
	{
		id: 'marketingactions',
		title: 'MODULE_MARKETINGACTIONS_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('marketingactions') || authorizer.cannot('view', 'marketingactions'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="marketingactions_rows"
				content={{ type: 'list', itemLayout: MarketingActionsListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'marw_table_uid', filt_clause: 'equals', filt_value: model.peop_uid }]}
			/>
		)
	},
	{
		id: 'commercialcampaigns',
		title: 'MODULE_COMMERCIALCAMPAIGNS_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('commercialcampaigns') || authorizer.cannot('view', 'commercialcampaigns'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="commercialcampaigns_rows"
				content={{ type: 'list', itemLayout: CommercialCampaignsListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'cmrw_table_uid', filt_clause: 'equals', filt_value: model.peop_uid }]}
			/>
		)
	},
	{
		id: 'dems',
		title: 'MODULE_DEMS_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('dems-recipients') || authorizer.cannot('view', 'dems-recipients'),
		content: ({ model }) => <DemsRecipientsExternalTab itemUid={model.peop_uid} />
	},
	{
		id: 'opportunities',
		title: 'MODULE_OPPORTUNITIES_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('opportunities') || authorizer.cannot('view', 'opportunities'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="opportunities"
				content={{ type: 'list', itemLayout: OpportunitiesListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'oppo_peop_uid', filt_clause: 'equals', filt_value: model.peop_uid }]}
			/>
		)
	},
	{
		id: 'contracts',
		title: 'MODULE_CONTRACTS_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('contracts') || authorizer.cannot('view', 'contracts'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="contracts"
				content={{ type: 'list', itemLayout: ContractsListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'cntr_peop_uid', filt_clause: 'equals', filt_value: model.peop_uid }]}
			/>
		)
	},
	{
		id: 'orders',
		title: 'MODULE_ORDERS_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) => isModuleDisabled('orders') || authorizer.cannot('view', 'orders'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="orders"
				content={{ type: 'list', itemLayout: OrdersListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'ords_peop_uid', filt_clause: 'equals', filt_value: model.peop_uid }]}
			/>
		)
	},
	{
		id: 'projects',
		title: 'MODULE_PROJECTS_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('projects') || authorizer.cannot('view', 'projects'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="projects"
				content={{ type: 'list', itemLayout: ProjectsListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'proj_peop_uid', filt_clause: 'equals', filt_value: model.peop_uid }]}
			/>
		)
	},
	{
		id: 'activities',
		title: 'MODULE_ACTIVITIES_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('activities') || authorizer.cannot('view', 'activities'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="activities"
				content={{ type: 'list', itemLayout: ActivitiesListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'acti_peop_uid', filt_clause: 'equals', filt_value: model.peop_uid }]}
			/>
		)
	},
	{
		id: 'tickets',
		title: 'MODULE_TICKETS_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('tickets') || authorizer.cannot('view', 'tickets'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="tickets"
				content={{ type: 'list', itemLayout: TicketsListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'tick_peop_uid', filt_clause: 'equals', filt_value: model.peop_uid }]}
			/>
		)
	},
	{
		id: 'phonecalls',
		title: 'MODULE_PHONECALLS_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('phonecalls') || authorizer.cannot('view', 'phonecalls'),
		content: ({ model }) => (
			<PhoneCallsChartTab
				defaultFilters={[{ filt_field: 'peop_uid', filt_clause: 'equals', filt_value: model.peop_uid }]}
			/>
		)
	},
	{
		id: 'lead-companies',
		title: 'DETAILS_TABS_LEAD_COMPANIES',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ authorizer }) =>
			authorizer.cannot('view', 'companies') || authorizer.cannot('view', 'lead-companies'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="companies"
				content={{ type: 'list', itemLayout: CompaniesListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[
					{ filt_field: 'comp_broker_peop_uid', filt_clause: 'equals', filt_value: model.peop_uid }
				]}
			/>
		)
	},
	{
		id: 'lead-people',
		title: 'DETAILS_TABS_LEAD_PERSON',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ authorizer }) => authorizer.cannot('view', 'people') || authorizer.cannot('view', 'lead-people'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="people"
				content={{ type: 'list', itemLayout: PeopleListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[
					{ filt_field: 'peop_broker_peop_uid', filt_clause: 'equals', filt_value: model.peop_uid }
				]}
			/>
		)
	}
];

export default tabs;
